import { render } from "./OrderShipToNotice.vue?vue&type=template&id=694f8d64"
import script from "./OrderShipToNotice.vue?vue&type=script&lang=js"
export * from "./OrderShipToNotice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__